import { ArrowLeft, AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const AuditPlanNotFound = () => {
  return (
    <div className="flex h-[calc(100vh-200px)] flex-col items-center justify-center gap-4">
      <AlertCircle className="h-16 w-16 text-muted-foreground" />
      <div className="text-center">
        <h2 className="text-2xl font-bold">Audit Plan Not Found</h2>
        <p className="text-muted-foreground">
          The audit plan you're looking for doesn't exist.
        </p>
      </div>
      <Button onClick={() => console.warn("Missing")}>
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back to Audit Plans
      </Button>
    </div>
  );
};
